import React from 'react'
import './CSS/Footer.css'

function Footer() {
  return (
    <footer class="footer">
    <div class="footer-column">
      <h1 class="footer-title">Blogs</h1>
      <p class="footer-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
         sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      <ul class="footer-link">
        <li class="footer-social-icons"><a href="#"><i class="footer-social-li fa fa-facebook"></i></a></li>
        <li class="footer-social-icons"><a href="#"><i class="footer-social-li fa fa-pinterest-p"></i></a></li>
        <li class="footer-social-icons"><a href="#"><i class="footer-social-li fa fa-twitter"></i></a></li>
        <li class="footer-social-icons"><a href="#"><i class="footer-social-li fa fa-instagram"></i></a></li>
      </ul>
    </div>
    <div class="footer-column">
      <h1 class="footer-title">sports</h1>
      <div class="footer-first-column">
        <div class="footer-flex">
          <img class="footer-image" src="https://images.pexels.com/photos/10153603/pexels-photo-10153603.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
          <p class="footer-img-desc">Sed ut perspiciatis unde omnis iste natus</p>
        </div>
        <div class="footer-flex">
          <img class="footer-image" src="https://images.pexels.com/photos/9365604/pexels-photo-9365604.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
          <p class="footer-img-desc">Sed ut perspiciatis unde omnis iste natus</p>
        </div>
      </div>
    </div>
    <div class="footer-column">
      <h1 class="footer-title">news</h1>
      <div class="footer-second-column">
        <div class="footer-flex">
          <img class="footer-image" src="https://images.pexels.com/photos/2870928/pexels-photo-2870928.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
          <p class="footer-img-desc">Sed ut perspiciatis unde omnis iste natus</p>
        </div>
        <div class="footer-flex">
          <img class="footer-image" src="https://images.pexels.com/photos/10990170/pexels-photo-10990170.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
          <p class="footer-img-desc">Sed ut perspiciatis unde omnis iste natus</p>
        </div>
      </div>
    </div>
    <div class="footer-column">
      <h1 class="footer-title">Links</h1>
      <ul class="footer-link">
        <li class="footer-links"><a href="">Home</a></li>
        <li class="footer-links"><a href="">Blogs</a></li>
        <li class="footer-links"><a href="">About</a></li>
        <li class="footer-links"><a href="">Term & Conditions</a></li>
        <li class="footer-links"><a href="">Privacy & Policy</a></li>
      </ul>
    </div>
  </footer>
  )
}

export default Footer